import React from 'react';
import { PropTypes } from 'prop-types';

import { Checkbox } from '@ontruck/orc';

const SepaCheckbox = ({ t, onChange, error }) => (
  <div className="SEPA-checkbox">
    {error && <p className="error">{t(`PaymentMethodSelector.sepa_error`)}</p>}
    <Checkbox
      name="SEPA"
      label={t(`PaymentMethodSelector.fields.SEPA`)}
      size="L"
      onChange={onChange}
    />
  </div>
);

SepaCheckbox.propTypes = {
  t: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.bool,
};

SepaCheckbox.defaultProps = {
  t: (t) => t,
  onChange: () => ({}),
  error: false,
};

export default SepaCheckbox;
